import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { DocStatusBanner } from "../components/DocStatusBanner";
import { renderMarkdown } from "../lib/markdown";
import { resolvePublicDoc } from "../lib/publicDocs";

export function PublicDocPage() {
	const { pathname } = useLocation();
	const doc = resolvePublicDoc(pathname);

	useEffect(() => {
		if (!doc) return;
		document.title = `${doc.title} · WorthyIdea`;
		const meta = document.querySelector('meta[name="robots"]');
		if (doc.status === "draft") {
			if (meta) meta.setAttribute("content", "noindex");
			else {
				const m = document.createElement("meta");
				m.name = "robots";
				m.content = "noindex";
				document.head.appendChild(m);
			}
		} else if (meta) {
			meta.remove();
		}
	}, [doc]);

	if (!doc) {
		return (
			<div className="space-y-4">
				<h2 className="font-display text-2xl text-wi-text">Page not found</h2>
				<p className="text-sm text-wi-text/70">That help or trust article is not published yet.</p>
				<Link to="/help" className="text-sm text-wi-gold underline-offset-2 hover:underline">
					Back to Help
				</Link>
			</div>
		);
	}

	const html = renderMarkdown(doc.source, doc.path);

	return (
		<article className="space-y-6">
			<DocStatusBanner status={doc.status} />
			<div
				className="public-doc prose-wi space-y-4 [&_code]:rounded [&_code]:bg-wi-text/6 [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-xs"
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{ __html: html }}
			/>
		</article>
	);
}
